/* eslint-disable */

import store from '@/store'
import router from '@/router'
import i18n from '@/i18n'
import {goldInfo} from '@/api/user'

var timer = null

// 定時回傳在線心跳 取得當下金幣數量
export function refreshGold() {
  if (store.getters.token != null) {
    store.commit('SET_GOLD_INFO', {
      gold: '<i class="fa fa-spinner fa-pulse fa-fw"></i>',
      common_gold: '<i class="fa fa-spinner fa-pulse fa-fw"></i>',
      commission_gold: '<i class="fa fa-spinner fa-pulse fa-fw"></i>',
    })
    goldInfo().then(response => {
      store.commit('SET_GOLD_INFO', response.data.data)
      store.commit('SET_GOLD_TOTAL', response.data.data)
      store.commit('SET_MAIN_GOLD', response.data.data)
      store.commit('SET_BONUS_GOLD', response.data.data)
      store.commit('SET_MAIN_POINT', response.data.data)
      store.commit('SET_MAIN_TURNOVER', response.data.data)
      store.commit('SET_POINTS', response.data.data)
      store.commit('SET_COMMISSION_GOLD', response.data.data)
    })
  }
}

// 正式環境線路不同 動態取url
export function getApiUrl() {
  // 決定api url
  if (store.getters.urlInfo.apiUrl) {
    return store.getters.urlInfo.apiUrl
  } else {
    return process.env.VUE_APP_BASE_API
  }
  // if (process.env.VUE_APP_BASE_API === '') {
  //   const currentUrl = new URL(window.location.href || document.location.href)
  //   // 正式環境可能走不同線路 依照前端域名決定
  //   let apiHost = currentUrl.host
  //   apiHost = apiHost.split('.')
  //   apiHost[0] = 'clientapi'
  //   return currentUrl.protocol + '//' + apiHost.join('.')
  // } else {
  //   return process.env.VUE_APP_BASE_API
  // }
}

export function getEventApiUrl() {
  if (process.env.VUE_APP_EVENT_API === '') {
    return 'https://event.gitpush.vip'
  } else {
    return process.env.VUE_APP_EVENT_API
  }
}

export function getFullDomain() {
  const protocol = window.location.protocol;
  const host = window.location.host;

  return protocol + '//' + host + '/'
}

export function setErrorMessage(response, errors) {
  errors.clear()
  if (response !== undefined && response.status !== undefined && response.status === 406) {
    let lastError = i18n.t('Bao.sorry_for_the_error')
    Object.keys(response.data.data).forEach(key => {
      lastError = response.data.data[key][0]
      errors.add({
        field: key,
        msg: lastError
      })
    })
  }
}

export function toErrorPage(message) {
  store.commit('SET_ERROR_MESSAGE', message)
  router.push({ path: '/error' }, () => {
  })
}

export function toMaintainPage(message) {
  store.commit('SET_ERROR_MESSAGE', message)
  router.push({ path: '/maintain' }, () => {
  })
}

export function toForbiddenPage(message) {
  store.commit('SET_ERROR_MESSAGE', message)
  router.push({ path: '/forbidden' }, () => {
  })
}

export function copyTextOfModal(modalBodyId, message) {

  var aux = document.createElement('input')

  // Assign it the value of the specified element
  aux.setAttribute('value', message)

  // Append it to the body
  // document.getElementById('addressDT').appendChild(aux)
  document.getElementById(modalBodyId).appendChild(aux)

  // Highlight its content
  aux.select()

  // Copy the highlighted text
  document.execCommand('copy')

  // Remove it from the body
  document.getElementById(modalBodyId).removeChild(aux)

  showNotice(i18n.t('Bao.copy_ok'))
}

// export function copyText(message) {

//   var aux = document.createElement('input')

//   // Assign it the value of the specified element
//   aux.setAttribute('value', message)

//   // Append it to the body
//   // document.getElementById('addressDT').appendChild(aux)
//   document.body.appendChild(aux)

//   // Highlight its content
//   aux.select()

//   // Copy the highlighted text
//   document.execCommand('copy')

//   // Remove it from the body
//   document.body.removeChild(aux)

//   showNotice(i18n.t('Bao.copy_ok'))
// }
export function copyText(message, url) {
  // Check if the device supports the Web Share API and is a mobile device using your detectMob function
  if (navigator.share && detectMob()) {
    navigator.share({
      title: 'Share this URL',
      text: 'Check out this promotion!',
      url: url,
    })
    .then(() => {
      showNotice(i18n.t('Bao.copy_ok'));
    })
    .catch(error => {
      console.log('Error sharing:', error);
    });
  } else {
    // The original copy functionality for non-mobile or unsupported devices
    var aux = document.createElement('input');

    aux.setAttribute('value', message);
    document.body.appendChild(aux);
    aux.select();
    document.execCommand('copy');
    document.body.removeChild(aux);

    showNotice(i18n.t('Bao.copy_ok'));
  }
}

export function showNotice(message, func, close, isMessageLabel, isUseOKText) {
  const data = {
    message: message,
    func: func,
    close: close === undefined ? true : close,
    isMessageLabel: isMessageLabel === undefined ? false : isMessageLabel,
    isUseOKText: isUseOKText === undefined ? false : isUseOKText
  }
  store.commit('SET_NOTICE_MESSAGE', data)
}
export function showRequest(message, func) {
  const data = {
    message: message,
    func: func
  }
  store.commit('SET_REQUEST_MESSAGE', data)
}
export function showAd(img, imgLink, urlOpenType, func, closeFunc) {
  const data = {
    img: img === undefined ? null : img,
    imgLink: imgLink === undefined ? null : imgLink,
    urlOpenType: urlOpenType,
    func: func,
    closeFunc: closeFunc
  }
  store.commit('SET_AD_MESSAGE', data)
}
export function showToast(message, func, close, isMessageLabel) {
  const data = {
    message: message,
    func: func,
    close: close === undefined ? true : close,
    isMessageLabel: isMessageLabel === undefined ? false : isMessageLabel
  }
  store.commit('SET_TOAST_MESSAGE', data);
}

export function showConfirm(message, submitLabel, cancelLabel , submitFunc, cancelFunc) {
  const confirm = {
    message: message,
    submitLabel: submitLabel,
    cancelLabel: cancelLabel,
    submitFunc: submitFunc,
    cancelFunc: cancelFunc
  }
  store.commit('SET_CONFIRM_DIALOG', confirm)
}

export function stripTags(input) {
  var html = '<p>' + input + '</p>'
  var div = document.createElement('div')
  div.innerHTML = html
  return div.textContent || div.innerText || ''
}

// 美洽客服
export function meiqiaInit(enterpriseId) {
  const externalFile = document.createElement('script')
  externalFile.setAttribute(
    'src',
    '/meiqia.js'
  )
  externalFile.async = true
  externalFile.onload = () => {
    _MEIQIA('entId', enterpriseId)
    _MEIQIA('manualInit')
    _MEIQIA('withoutBtn')
  }
  document.head.appendChild(externalFile)
}

export function isiOS() {
  return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
}

export function detectMob() {
  const toMatch = [
    /Android/i,
    /webOS/i,
    /iPhone/i,
    /iPad/i,
    /iPod/i,
    /BlackBerry/i,
    /Windows Phone/i
  ];

  return toMatch.some((toMatchItem) => {
    return navigator.userAgent.match(toMatchItem);
  });
}

export function notAppPage() {
  const url = window.location.href || document.location.href

  return url.includes('/web/') || url.includes('/agent') || url.includes('/error') || url.includes('/critical')
}

export function forceApp(currentRouteName, forceSetting) {
  if ((currentRouteName !== 'Register' && currentRouteName !== 'Share' && currentRouteName !== 'Error' && currentRouteName !== 'Critical') && forceSetting === 1 && detectMob() && !notAppPage()) {
    return true
  } else {
    return false
  }
}

export function newWindows(dataObject) {
  var newWindow = null
  if (dataObject.open_type === 'new') {
    return '_blank'
  }

  if (dataObject.open_type === 'self') {
    return '_self'
  }
}

export async function loadDynamicCss() {
  let currentTheme = localStorage.getItem('theme')
  if (!currentTheme) {
    currentTheme = process.env.VUE_APP_THEME
    localStorage.setItem('theme', currentTheme)
  }
  store.commit('SET_THEME', currentTheme);
  if (window.location.pathname.startsWith('/campaign')) {
    const cssFiles = ['campaign_reset.css', 'style_special_deposit.css']
    await Promise.all(cssFiles.map(file => import('@/assets/' + currentTheme + '/css/' + file)))
    return;
  } else if (window.location.pathname.startsWith('/match/DailyAttend')) {
    const cssFiles = ['event-bonus.css']
    await Promise.all(cssFiles.map(file => import('@/assets/theme_gold/css/dailyAttend/' + file)))
    return;
  } else if (window.location.pathname.startsWith('/affiliate')) {
    const cssFiles = ['proxy_style.css']
    await Promise.all(cssFiles.map(file => import('@/assets/theme_gold/css/proxy/' + file)))
    return;
  } else if (window.location.pathname.startsWith('/championship')) {
    const cssFiles = ['championship.css']
    await Promise.all(cssFiles.map(file => import('@/assets/theme_white/css/' + file)))
    return;
  } else {
    // Import all files except 'style.css'
    const cssFiles = ['reset.css', 'main.css','footer.css']
    // Await the import of all other files before importing 'style.css'
    await Promise.all(cssFiles.map(file => import('@/assets/' + currentTheme + '/css/' + file)))
    // import 'style.css' 
    await import('@/assets/' + currentTheme + '/css/style.css')
  }

}

export function handleTokenUrl(urlString, token) {
  const url = new URL(urlString)
  const params = new URLSearchParams(url.search)
  params.delete('token')
  if (token) {
    params.append('token', token)
  } else {
    params.append('token', '')
  }
  return `${url.origin}${url.pathname}?${params.toString()}`
}

export function getSumFloatNum(dataList, resultDigit) {
  const maxDecimalLength = Math.max(...dataList.map(numStr => (numStr.split('.')[1] || '').length))
  const sum = dataList.reduce((total, numStr) => {
      const [integerPart, decimalPart] = numStr.split('.')
      const paddedDecimalPart = (decimalPart || '').padEnd(maxDecimalLength, '0')
      return total + parseInt(integerPart + paddedDecimalPart)
  }, 0)
  const sumWithDecimal = (sum / Math.pow(10, maxDecimalLength)).toFixed(resultDigit)

  return sumWithDecimal
}

export function setCurrencySymbol() {
  let currency = process.env.VUE_APP_CURRENCY
  if (currency === 'JPY') {
    store.commit('SET_CURRENCY', '¥')
  } else {
    store.commit('SET_CURRENCY', '$')
  }
}

export function isCrossDay(currentTimeStamp, storedTimeStamp) {
  const currentDay = new Date(currentTimeStamp * 1000).getDate();
  const storedDay = new Date(storedTimeStamp * 1000).getDate();
  return currentDay !== storedDay; // false代表還是同一天
}